<template>
    <div class="button" :class="{active:active}"  @click.prevent="clickButton" :style="{left:posX+'px',top:posY+'px'}"><span><slot></slot></span></div>
</template>

<script>
    export default {
        name: "Button",
        props: {
            firstClick:{type:Boolean, default:false},
            active:{type:Boolean, default:false},
            number: {type: Number, default: 0},
            posX: {type: Number, default: 0},
            posY: {type: Number, default: 0}
        },
        methods: {
            clickButton() {
                this.$emit('update:selected_button',this.number);
            }
        }
    }
</script>